<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name, spacing]"
    :style="mainCssVars"
  >
    <grid
      :class="[`${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__media`]"
        :layout="[
          { size: 1, x: 1, width: 12, y: 1, height: 1 },
          { size: 3, x: 1, width: 24, y: 1, height: 1 },
        ]"
      >
        <transition name="fade">
          <m-media
            :cms="cms"
            :layout="[
              { size: 0, bound: 667, ratio: [375, 667] },
              { size: 1, bound: 768, ratio: [1480, 833] },
              { size: 2, bound: 992, ratio: [1480, 833] },
              { size: 3, bound: 1200, ratio: [1480, 833] },
              { size: 4, bound: 1440, ratio: [1480, 833] },
            ]"
          />
        </transition>
      </grid-item>
      <grid-item
        :class="[`${name}__grid-item`, `${name}__caption`]"
        :layout="[
          { size: 1, x: 1, width: 12, y: 1, height: 1 },
          { size: 3, x: 1, width: 24, y: 1, height: 1 },
        ]"
      >
        <grid
          :html-tag="`figcaption`"
          :layout="[
            {
              size: 1,
              columns: 'repeat(12, 1fr)',
              gap: '6px',
            },
            {
              size: 2,
              columns: 'repeat(24, 1fr)',
              gap: '10px',
            },
          ]"
          :class="['grid--container', `${name}__grid`]"
        >
          <grid-item
            :class="`${name}__grid-item`"
            :layout="[
              { size: 1, x: 1, width: 12 },
              { size: 2, x: 1, width: 24 },
              { size: 3, x: 1, width: 24 },
              { size: 4, x: 1, width: 24 },
            ]"
          >
            <m-section-header-v2
              v-if="cms.heading"
              :cms="cms"
              :class="`${name}__header`"
            />
            <div :class="`${name}__collection`">
              <a-link-v2
                v-for="(item, index) in cms.clients"
                :key="index"
                :href="item.href ? item.href.url : ''"
                :class="[`${name}__item`, getClass(index + 1)]"
              >
                <a-image-v2
                  v-if="show && (item.image || {}).filename"
                  :src="item.image.filename"
                  :alt="item.image.alt"
                  :layout="[
                    { size: 0, bound: 150, ratio: [150, 150] },
                    { size: 1, bound: 150, ratio: [150, 150] },
                    { size: 2, bound: 150, ratio: [150, 150] },
                    { size: 3, bound: 206, ratio: [206, 206] },
                  ]"
                  :class="`${name}__image`"
                />
              </a-link-v2>
            </div>
          </grid-item>
        </grid>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import MMedia from '~/components/molecules/m-media/m-media'
import MSectionHeaderV2 from '~/components/molecules/m-section-heading/m-section-header-v2'
export default {
  components: { MMedia, MSectionHeaderV2 },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      name: 'o-clients-v3',
      show: true,
      loaded: false,
      video: false,
    }
  },
  computed: {
    spacing() {
      return this.cms.spacing
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#000000',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#FFFFFF'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || 'inherit'
        ),
        '--filter': this.cms.filter || null,
        '--filter-logo': this.cms.logo_filter || null,
      }
    },
  },
  methods: {
    getClass(index) {
      if (index % 2 === 0) {
        return `item-${index}`
      } else {
        return `item-${index}`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-clients-v3 {
  background: var(--bg-color);
  color: var(--text-color);
  &__media {
    ::v-deep img {
      filter: var(--filter);
    }
  }
  &__collection {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 6px;
    grid-auto-flow: dense;
    align-items: stretch;
  }
  &__caption {
    align-self: center;
  }
  ::v-deep .a-heading {
    z-index: 10;
  }

  /* &__image {
    ::v-deep img {
      filter: var(--filter-logo);
    }
  } */
  &__item {
    z-index: 10;
    border: 1px solid var(--text-color);
    width: 100%;
    display: grid;
    align-items: center;
    justify-content: center;
    backdrop-filter: var(--filter-logo);
  }
}

@include media-breakpoint-up(sm) {
  .o-clients-v3 {
    &__collection {
      grid-template-columns: repeat(6, 1fr);
      grid-gap: 10px;
    }
    &__item {
      justify-self: center;
      &.item-1 {
        grid-area: 1/ 1 / auto / auto;
      }
      &.item-2 {
        grid-area: 2/ 2 / auto / auto;
      }
      &.item-3 {
        grid-area: 1/ 3 / auto / auto;
      }
      &.item-4 {
        grid-area: 2/ 4 / auto / auto;
      }
      &.item-5 {
        grid-area: 1/ 5 / auto / auto;
      }
      &.item-6 {
        grid-area: 2/ 6 / auto / auto;
      }
    }
  }
}
</style>
